var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-1"},[_c('v-img',{staticClass:"mb-2 hidden-md-and-down",attrs:{"width":"50%","src":_vm.documentURL}}),_c('v-img',{staticClass:"mb-2 hidden-lg-and-up",attrs:{"width":"100%","src":_vm.documentURL}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }